import { render } from "./WelcomeToPharmacy.vue?vue&type=template&id=108f36c9&scoped=true&ts=true"
import script from "./WelcomeToPharmacy.vue?vue&type=script&lang=ts"
export * from "./WelcomeToPharmacy.vue?vue&type=script&lang=ts"

import "./WelcomeToPharmacy.vue?vue&type=style&index=0&id=108f36c9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108f36c9"]])

export default __exports__